import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../utils/GlobalContext";
import {
  Avatar,
  TextInput,
  Select,
  Divider,
  Button,
  Card,
  Badge,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { AiOutlineDelete } from "react-icons/ai";
import { RiAddBoxFill } from "react-icons/ri";

const PatientProfile = () => {
  // Hooks
  const { user } = useContext(GlobalContext);

  useEffect(() => {});

  return (
    <div
      className="Home"
      style={{
        padding: "100px 8vw 15px 8vw",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }}>
        <div
          className="col1"
          style={{
            marginRight: 100,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar color="pink" radius="xl" size={250}>
            MK
          </Avatar>
          <Button style={{ marginTop: 25, width: 200 }} color="indigo">
            Change Picture
          </Button>
          <Button
            style={{ marginTop: 20, width: 200 }}
            color="red"
            variant="outline"
          >
            Delete Picture
          </Button>
        </div>
        <div className="col2">
          <div style={{ display: "flex" }}>
            <TextInput
              placeholder="First Name"
              label="First Name"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
            <TextInput
              placeholder="Last Name"
              label="Last Name"
              style={{ marginBottom: 20, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <DatePicker
              placeholder="Date of Birth"
              label="Date of Birth"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <Select
              label="Gender"
              placeholder="Gender"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
              data={[
                { value: "male", label: "Male" },
                { value: "female", label: "Female" },
              ]}
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextInput
              placeholder="Address"
              label="Address"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
            <TextInput
              placeholder="Email"
              label="Email"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <TextInput
              placeholder="Phone Number"
              label="Phone Number"
              style={{ marginBottom: 20, marginRight: 75, width: 250 }}
            />
          </div>
          <Divider
            my="xs"
            label="Emergency Contact"
            labelPosition="center"
            style={{ marginBottom: 20 }}
          />
          <Card
            shadow="sm"
            padding="sm"
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <div style={{ display: "flex" }}>
              <Avatar radius="xl" style={{ marginRight: 5 }} />
              <div>
                <h3>Tucky Habert</h3>
                <Badge variant="outline">Primary</Badge>
              </div>
            </div>
            <h4>(709) 546 1234</h4>
            <Button color="red" size="sm" compact variant="light">
              <AiOutlineDelete />
            </Button>
          </Card>
          <Card
            shadow="sm"
            padding="sm"
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              marginBottom: 20,
            }}
          >
            <div style={{ display: "flex" }}>
              <Avatar radius="xl" style={{ marginRight: 5 }} />
              <div>
                <h3>Robie Manny</h3>
                <Badge variant="outline">Secondary</Badge>
              </div>
            </div>
            <h4>(709) 556 1224</h4>
            <Button color="red" size="sm" compact variant="light">
              <AiOutlineDelete />
            </Button>
          </Card>
          <Button variant="light" color="indigo" size="md">
            <RiAddBoxFill style={{ marginRight: 5 }} />
            Add Contact
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PatientProfile;
